import { SocketEvent } from '@/services/ws/core/event'

class NewBonusEvent extends SocketEvent {
  async handle(_data, { store }) {
    await store.dispatch('promotions/add_newPromotions')
  }
}

export const newBonusEvent = new NewBonusEvent()
